import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

import { PersistenceService } from "../../store/model/persistence.service";
import { GlobalOccasionValidity } from "../../store/validity/state";
import { GlobalOccasionSection } from "../../data/model";
import {
    createGlobalOccasionSection,
    createGlobalOccasionEntry,
} from "../../data/model-utils";
import { allSatisfy, trackEntity } from "../../utils/utils";
import { LocalState } from "./global-occasion.component";
import {
    GlobalOccasionOption,
    globalOccasionOptions,
} from "./global-occasion.constants";
import { ConfirmModalComponent } from "../../components/modals/confirm-modal.component";
import { Observable } from "rxjs";

@Component({
    selector: "zbd-global-occasion-section-list",
    templateUrl: "global-occasion-section-list.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlobalOccasionSectionListComponent {
    @Input() persistence: PersistenceService;
    @Input() state$: Observable<LocalState>;
    @Input() validity: GlobalOccasionValidity;

    options = globalOccasionOptions;

    trackEntity = trackEntity;

    addSection(option: GlobalOccasionOption) {
        const entries = option.entries.map((e) =>
            createGlobalOccasionEntry(e.label),
        );
        const section = createGlobalOccasionSection(
            option.key,
            option.label,
            entries,
        );
        this.persistence.addDeepGlobalOccasionSection(section);
    }

    deleteSection(section: GlobalOccasionSection) {
        ConfirmModalComponent.open(
            `Möchten Sie das Beratungsfeld '${section.CategoryName}' löschen?`,
            () => this.persistence.deleteGlobalOccasionSection(section),
        );
    }

    isAvailable(state: LocalState, option: GlobalOccasionOption): boolean {
        return allSatisfy(
            state.globalOccasion.GlobalOccasionSections,
            (section) => {
                return section.CategoryKey !== option.key;
            },
        );
    }

    selectionChanged(
        state: LocalState,
        option: GlobalOccasionOption,
        checked: boolean,
    ) {
        if (checked) {
            this.addSection(option);
        } else {
            const section = state.globalOccasion.GlobalOccasionSections.find(
                (section) => section.CategoryKey === option.key,
            );
            this.deleteSection(section);
        }
    }
}
